import axios from "axios";
import moment from "moment";

import { Maintenance } from "api/memberPortal/project/maintenance/maintenance.types";
import { PublicMaintenance } from "api/public/project/maintenance/maintenance.types";

function latestApprovedMaintenance(
  maintenances: Maintenance[] | PublicMaintenance[] = [],
) {
  const latestApprovedMaintenance = maintenances
    .filter((maintenance) => maintenance.status === "Approved")
    .sort((a, b) =>
      moment(a.completion_date).isBefore(moment(b.completion_date)) ? 1 : -1,
    )[0];

  return latestApprovedMaintenance;
}

export { latestApprovedMaintenance };

interface MailerData {
  subject: string;
  recipients: {
    to: string[]; // TODO: MAKE TYPES
    cc: string[]; // TODO: MAKE TYPES
  };
  alert_type?: string; // TODO: MAKE TYPES
  alert_text?: string;
  alert_type_id?: string | number;
  alert_source?: string; // TODO: MAKE TYPES
  note?: string;
}

export const handleAlertAndMailer = async (
  csrfToken: string,
  authToken: string,
  data: MailerData,
) => {
  let headers = {
    "X-CSRFToken": csrfToken,
  };
  if (authToken) {
    // @ts-ignore - We wont need this once we switch to RTKQ so im not going to bother typing it
    headers["Authorization"] = `Token ${authToken}`;
  }
  await axios
    .post(
      `${import.meta.env.VITE_DJANGO_ENDPOINT}alerts/send_alert_and_mail/`,
      data,
      {
        withCredentials: true,
        headers: headers,
      },
    )
    .then(() => {
      console.log("Alert and email sent successfully.");
    })
    .catch((error) => console.log("Unable to create alert and email.", error));
};
